import React from "react";
export default function ZoomTool(props) {
    return (React.createElement("div", { className: "zoom-tool" },
        React.createElement("button", { className: "zoom-out zoom", onClick: (e) => {
                props.setScale((s) => s * 1.1);
            } }),
        React.createElement("button", { className: "zoom-in zoom", onClick: (e) => {
                props.setScale((s) => Math.max(0.1, s / 1.1));
            } })));
}
